import { heroImage, stats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[600px] md:h-[680px] overflow-hidden">
      <img
        src={heroImage}
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-8 flex flex-col items-center justify-center text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm animate-fade-up">
          <i className="ri-play-circle-line text-base"></i>
          在线观看 · 免费观看 · 高清播放
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50 animate-fade-up">
          茶杯狐影视：在线观看与高清播放的集中入口
        </h1>

        <p className="mt-5 max-w-2xl text-sm md:text-base text-background-100/85 leading-relaxed animate-fade-up">
          在同一个页面里整理在线观看、免费观看、高清播放与下载缓存等常见需求。
          无论是通勤路上、客厅大屏还是深夜独自观影，都能找到合适的清晰度与观看方式。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          <a
            href="#catalog"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600"
          >
            <i className="ri-play-fill"></i>
            立即在线观看
          </a>
          <a
            href="#guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors border border-background-50/40 text-background-50 hover:bg-background-50/10"
          >
            <i className="ri-book-open-line"></i>
            查看观看指南
          </a>
        </div>

        <dl className="mt-12 w-full max-w-3xl grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center gap-1 px-3 py-4 rounded-lg border border-background-50/15 bg-background-50/5 backdrop-blur-sm"
            >
              <i className={`${item.icon} text-xl text-primary-300`}></i>
              <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">
                {item.value}
              </dt>
              <dd className="text-xs md:text-sm text-background-100/80">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}